<ng-container *ngIf="!!get">
    <tt-input class="col-md-6 col-xs-12 sp-0" ttLabel="title" [(ttModel)]="get.title"></tt-input>
    <tt-editor class="flex-1" ttLabel="html_content_base64" [(ttModel)]="get.html_content_base64" ttHeight="100%" [(ttProcessing)]="editorProcessing"></tt-editor>
    <div>
        <tt-button
            class="col-xs-12 col-md-2 sp-2"
            *ngIf="+get.docarticle_keyno > 0"
            ttText="docarticleedit_delete"
            ttType="danger"
            ttIcon="far fa-trash"
            (ttClick)="deleteDocArticle()"
            [ttLoading]="deleting"
        ></tt-button>
        <tt-button-save class="col-xs-12 col-md-2 sp-2 pull-right" ttText="docarticleedit_save" (ttClick)="saveDocArticle()" [ttLoading]="saving" [ttDisabled]="editorProcessing"></tt-button-save>
        <tt-button class="col-xs-12 col-md-2 sp-2 pull-right" ttText="cancel" ttType="secondary" (ttClick)="submit.emit({ back: 1, docarticle_keyno: '' + get.docarticle_keyno })"></tt-button>
    </div>
</ng-container>

<ng-container *ngIf="!get">
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <div class="col-xs-12 sp-0 flex-1 tt-skeleton" style="height: 20rem; margin-bottom: 7px"></div>
    <div>
        <div class="col-xs-12 col-md-2 sp-2 pull-right">
            <div class="tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-success-color); margin-bottom: 7px"></div>
        </div>
        <div class="col-xs-12 col-md-2 sp-2 pull-right">
            <div class="tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-secondary-color); margin-bottom: 7px"></div>
        </div>
    </div>
</ng-container>

<ng-template #inputskeleton>
    <div class="col-xs-4 sp-0 tt-skeleton" style="width: 40%; height: var(--tt-font-size-sm); margin-bottom: 4px"></div>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
</ng-template>
